import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, 
    YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getAktiviterByUserid } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import {Grid} from '@material-ui/core'
/*const data = [
  { name: "JAN", Nytt: 5000, Förlängning: 200 },
  { name: "FEB", Nytt: 5000, Förlängning: 500 },
  { name: "MAR", Nytt: 7000, Förlängning: 1000 },
  { name: "APR", Nytt: 8000, Förlängning: 3000 },
  { name: "MAJ", Nytt: 7000, Förlängning: 1000 },
  { name: "JUN", Nytt: 5000, Förlängning: 1500 },
  { name: "JUL", Nytt: 6000, Förlängning: 1000 },
  { name: "AUG", Nytt: 2000, Förlängning: 1000 },
  { name: "SEP", Nytt: 500, Förlängning: 2500 },
  { name: "OKT", Nytt: 4000, Förlängning: 3000 },
  { name: "NOV", Nytt: 4000, Förlängning: 2000 },
  { name: "DEC", Nytt: 1000, Förlängning: 2000 }
];
*/
const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class Aktiviteter extends Component {
  state={
    DashboardFilterOption:[],
    done: false
  }
  intervalID = null
  componentDidMount=()=>{ 
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    const isFrom= isUndefined(this.props.isFrom)?0:this.props.isFrom
        if(isUndefined(this.props.isFrom)?0:this.props.isFrom === 1){
            this.props.getAktiviterByUserid(userid,Afid,[])
            .then(() => {
              this.setState({done: true})   
          })
        }
        else{
            this.props.getAktiviterByUserid(userid,Afid,this.props.DashboardFilterOption)
            .then(() => {
              this.setState({done: true})   
          })
        }
    this.intervalID = setInterval(
      () => {
        if(this.state.done === true){            
          this.setState({done: false}) 
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        const isFrom= isUndefined(this.props.isFrom)?0:this.props.isFrom
        console.log(isUndefined(this.props.isFrom)?0:this.props.isFrom)
            if(isUndefined(this.props.isFrom)?0:this.props.isFrom === 1){
                this.props.getAktiviterByUserid(userid,Afid,[])
                .then(() => {
                  this.setState({done: true})   
              })
            }
            else{
                this.props.getAktiviterByUserid(userid,Afid,this.props.DashboardFilterOption)
                .then(() => {
                  this.setState({done: true})   
              })
            }
            }
      },
      30000
  );
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
 const isFrom= isUndefined(this.props.isFrom)?0:this.props.isFrom
 if(this.props.DashboardFilterOption !== this.state.DashboardFilterOption){
  if(isUndefined(this.props.isFrom)?0:this.props.isFrom === 1){
    
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            this.props.getAktiviterByUserid(userid,Afid,this.props.DashboardFilterOption)
            .then(() => {
              this.setState({done: true})   
          })
            /* */
            this.setState({
                DashboardFilterOption:this.props.DashboardFilterOption 
            }) 
    }
  }
}
createData=()=>{
  if(isEmpty(this.props.AktiviterArr)){return [
      {name:<IntlMessages id="Options.Contactperson.Short"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option3"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option1"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option4"/>,Antal:0},
  ]}
  else{
    return this.props.AktiviterArr
    }
}
formatNumber=(number)=>{
  if(number > 1000000){
    return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
}
  else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return number
}
}
render() {
  const formatter = new Intl.NumberFormat('fr',{ notation: "compact" ,
   compactDisplay: "short" })
    return (
    <Grid container>
        <Grid item xs={12}>
        <ResponsiveContainer className="gx-barchart" width="95%" height={200}>
        <BarChart
        data={this.props.AktiviterArr}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
        <XAxis tick={{ fill: 'white' }} dataKey="name" />
        <YAxis tick={{ fill: 'white' }} domain={[0, 'dataMax + 1']} allowDecimals={false} type="number" tickFormatter={tick => {
              return this.formatNumber(tick)
            }}/>
        <Tooltip cursor={{ stroke: '#0c969c', strokeWidth: 1, fill: "#0c969c" }} 
        formatter={(value) => this.formatNumber(value)}  
        />
        <Legend formatter={renderColorfulLegendText} iconType="circle" />
        <Bar dataKey="Antal" name={<IntlMessages id="Table.Quantity"/>} fill="#075a5f" />
        </BarChart>

        </ResponsiveContainer>
        </Grid>
       
    </Grid>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard }) => {
  const { width } = settings;
  const { authUser} = auth;
  const { AktiviterArr,DashboardFilterOption} = DashBoard;
  return { width,authUser,AktiviterArr,DashboardFilterOption };
};
function mapDispatchToProps(dispatch) {
  return {
    getAktiviterByUserid: (userid,Afid,DashboardFilterOption) => dispatch(getAktiviterByUserid(userid,Afid,DashboardFilterOption)),
      dispatch
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Aktiviteter);
